import '../../styles/auth.css';
import { register, AuthError } from '../../auth';
import { bootShell, showError, clearMessages, describeError } from './_shell';

bootShell();

// Forward `?next=` to the login link so a user who clicks "Sign in" instead
// of registering still lands where they were headed.
const params = new URLSearchParams(location.search);
const next = params.get('next');
const loginLink = document.getElementById('login-link') as HTMLAnchorElement | null;
if (loginLink && next && next.startsWith('/') && !next.startsWith('//')) {
  loginLink.href = `/login.html?next=${encodeURIComponent(next)}`;
}

const form = document.getElementById('register-form') as HTMLFormElement;
const emailInput = document.getElementById('email') as HTMLInputElement;
const passwordInput = document.getElementById('password') as HTMLInputElement;
const displayNameInput = document.getElementById('display_name') as HTMLInputElement;
const termsInput = document.getElementById('accept_terms') as HTMLInputElement;
const submitBtn = document.getElementById('submit-btn') as HTMLButtonElement;

form.addEventListener('submit', async (ev) => {
  ev.preventDefault();
  clearMessages();

  const email = emailInput.value.trim();
  const password = passwordInput.value;
  const displayName = displayNameInput.value.trim();
  const acceptTerms = termsInput.checked;

  if (!email || !password) {
    showError('Email and password are required.');
    return;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showError('That email does not look right.');
    return;
  }
  if (password.length < 8) {
    showError('Password must be at least 8 characters.');
    return;
  }
  if (!acceptTerms) {
    showError('Please accept the Terms to continue.');
    return;
  }

  submitBtn.disabled = true;
  try {
    await register({
      email,
      password,
      display_name: displayName || undefined,
      accept_terms: true,
    });
    // Drop them into the main app — the verify-email banner there will prompt
    // them to check their inbox.
    location.href = '/';
  } catch (err: any) {
    if (err instanceof AuthError && err.status === 409) {
      showError('That email is already registered. Try signing in instead.');
    } else {
      showError(describeError(err, 'Could not create your account.'));
    }
    submitBtn.disabled = false;
  }
});
